import React, { useState, useEffect } from "react";
import { Table, Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import BasicPagination from "../../../../Pagination/Pagination";
import moment from "moment";
import { getNominationsActivity } from "../../../../../store/actions/SuperAdminActions/commonSuperAdmin";
import { SmallLoader } from "../../../../Loader/SmallLoader";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import { Filter } from "../SuperAdminMainNominations";

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Button, Form } from "react-bootstrap";
import { toTimestamp } from "../../../../../function/common";
import {
  FormControl,
  IconButton,
  InputLabel,
  Radio,
  Select,
  TextField,
} from "@material-ui/core";
import { SortComponent } from "../../../../reusableComponents/SortAndFilterComponent/SortComponent";
import SelectFilter from "../../../../reusableComponents/selectFilter";

const SuperAdminNominationViewActivity = (props) => {
  const [loading, setLoading] = useState(false);
  //state
  const [page, setPage] = useState(1);
  const [showFilter, handleShowFilter] = useState(false);

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);

    setPage(pageNo);
  };
  const onSuccessNominations = () => {
    setLoading(false);
  };
  const onErrorNominations = () => {
    setLoading(false);
    setCity("");
    setStartDate("");
    setEndDate("");
    setStartDateTimeStamp("");
    setEndDateTimeStamp("");
    setSearch("");
  };

  const [search, setSearch] = useState("");
  const [sort, setSort] = useState(true);
  const [searchFlag, setSearchFlag] = useState(false);
  const [city, setCity] = useState("");
  const [searchClick, setSearchClick] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [startDateTimeStamp, setStartDateTimeStamp] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endDateTimeStamp, setEndDateTimeStamp] = useState("");
  const [sortByValue, setSortBy] = useState("Restaurant name");

  const onStartDateChange = (e) => {
    setStartDate(e.target.value);
    // setStartDateTimeStamp(toTimestamp(e.target.value));
  };
  const onEndDateChange = (e) => {
    setEndDate(e.target.value);
    // setEndDateTimeStamp(toTimestamp(e.target.value));
  };

  const sortByChangeCode = (event) => {
    const sortByValue = event.target.value;
    let startDate = "";
    let endDate = new Date();
    setSortBy(sortByValue);
    if (sortByValue === "Restaurant name") {
      setSort(true);
      setStartDate("");
      setEndDate("");
      setStartDateTimeStamp("");
      setEndDateTimeStamp("");
    } else if (sortByValue === "Today") {
      startDate = new Date();
      setStartDate(startDate);
      setEndDate(endDate);
      setStartDateTimeStamp(toTimestamp(startDate));
      setEndDateTimeStamp(toTimestamp(endDate));
    } else if (sortByValue === "Last month") {
      startDate = new Date(new Date().setDate(new Date().getDate() - 30));
      setStartDate(startDate);
      setEndDate(endDate);
      setStartDateTimeStamp(toTimestamp(startDate));
      setEndDateTimeStamp(toTimestamp(endDate));
    } else if (sortByValue === "Last 3 months") {
      startDate = new Date(new Date().setDate(new Date().getDate() - 90));
      setStartDate(startDate);
      setEndDate(endDate);
      setStartDateTimeStamp(toTimestamp(startDate));
      setEndDateTimeStamp(toTimestamp(endDate));
    }
  };

  const onCancelClick = () => {
    handleShowFilter(!showFilter);
    setCity("");
    if (
      sortByValue !== "Today" ||
      !sortByValue !== "Last month" ||
      sortByValue !== "Last 3 months"
    ) {
      setStartDate("");
      setEndDate("");
      setStartDateTimeStamp("");
      setEndDateTimeStamp("");
    }
  };
  const onSearchClick = (e) => {
    setSearch(e.target.value);
    e.target.value === "" && setSearchFlag(!searchFlag);
  };

  const [state, setState] = useState({
    anchorEl: null,
    restaurantReverse: "",
  });

  /*********************************
   * @DESC SELECTED DATE FILTER ACTION
   *********************************/
  const [dateQuery, setDateQuery] = useState("");
  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };

  const handleClose = () => {
    setState({
      ...state,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => () => {
    if (state.anchorEl) {
      setState({
        ...state,
        restaurantReverse: value,
        anchorEl: false,
      });
    }
  };

  useEffect(() => {
    setLoading(true);
    const token = props.auth.user.accessToken;
    props.getNominationsActivity(
      token,
      page,
      search,
      sort,
      // startDateTimeStamp,
      // endDateTimeStamp,
      startDate === "" ? moment().format("YYYY-MM-DD") : startDate,
      endDate === "" ? moment().format("YYYY-MM-DD") : endDate,
      city,
      onSuccessNominations,
      onErrorNominations
    );
  }, [page, searchClick, searchFlag]);

  useEffect(() => {
    setLoading(true);
    const token = props.auth.user.accessToken;
    props.getNominationsActivity(
      token,
      page,
      search,
      sort,
      dateQuery.startDate !== undefined
        ? dateQuery.startDate
        : moment().format("YYYY-MM-DD"),
      dateQuery.endDate !== undefined
        ? dateQuery.endDate
        : moment().format("YYYY-MM-DD"),
      city,
      onSuccessNominations,
      onErrorNominations
    );
  }, [page, searchClick, searchFlag, dateQuery]);

  const filterData = props?.allNominationsActivity?.data;
  if (state?.restaurantReverse === "A-Z") {
    filterData.sort((a, b) => {
      if (a?.name.toLowerCase() < b?.name.toLowerCase()) return -1;
      if (a?.name.toLowerCase() > b?.name.toLowerCase()) return 1;
      return 0;
    });
  } else if (state?.restaurantReverse === "Z-A") {
    filterData.sort((a, b) => {
      if (a?.name.toLowerCase() < b?.name.toLowerCase()) return 1;
      if (a?.name.toLowerCase() > b?.name.toLowerCase()) return -1;
      return 0;
    });
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation
              backIcon={true}
              displayText="Back"
              link="/superadminnomination"
            />
            <div className="super-admin-inside-right-side-panel">
              <div className="pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Nomination Details - Activity
                </div>
              </div>
              <div className="row">
                <Filter
                  SortBy={sortByValue}
                  onSearchChange={onSearchClick}
                  onKeyDown={(e) =>
                    e.keyCode === 13 && setSearchClick(!searchClick)
                  }
                  sortByChangeCode={sortByChangeCode}
                  search={search}
                  handleShowFilter={() => {
                    handleShowFilter(!showFilter);
                  }}
                  openSortModal={handleClick}
                  anchorElState={state.anchorEl}
                  closedSortModal={handleClose}
                  handleSelectClick={(data) => handleSelect(data)}
                  dateTimeChange={(data, type) =>
                    onDateChangeHandler(data, type)
                  }
                />
              </div>
              {showFilter && (
                <div className="col-12  mt-3">
                  <div className="enWhiteBox mt-3">
                    <div className="row">
                      {/* <div className="col-6">
                        <div
                          className="d-flex justify-content-start"
                          style={{ alignItems: "center" }}
                        >
                          <TextField
                            type="date"
                            variant="outlined"
                            onChange={onStartDateChange}
                            value={startDate}
                          />
                          &nbsp;To&nbsp;
                          <TextField
                            type="date"
                            variant="outlined"
                            onChange={onEndDateChange}
                            value={endDate}
                          />
                        </div>
                      </div> */}
                      <div className="col-6">
                        {" "}
                        <Form.Group>
                          <Form.Control
                            type="text"
                            placeholder="Search by Location"
                            onChange={(e) => setCity(e.target.value)}
                            value={city}
                            className="amSearch"
                          />
                        </Form.Group>
                      </div>
                    </div>
                    <div className="d-flex align-items-center mt-4">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5"
                        onClick={onCancelClick}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5"
                        onClick={() => setSearchClick(!searchClick)}
                      >
                        Search
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              <div className="user-table-reusable-superadmin table-responsive">
                <Table className="enMinWidth900 HideShowTable">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <th style={{ width: "25%" }} className="f12-500">
                        Restaurant Name
                      </th>
                      <th style={{ width: "20%" }} className="f12-500">
                        User Name
                      </th>
                      <th style={{ width: "20%" }} className="f12-500">
                        Date - Time
                      </th>
                      <th style={{ width: "35%" }} className="f12-500">
                        Google Places ID
                      </th>
                      {/* <th style={{ width: "15%" }} className="f12-500">
                        Nomination
                      </th> */}
                    </tr>
                  </thead>
                  {props.auth.secondary_loader ? (
                    <SmallLoader />
                  ) : (
                    filterData &&
                    filterData.map((activity, index) => (
                      <tbody key={index}>
                        <tr className="enUserFavoritesTableBody">
                          <td style={{ width: "25%" }}>
                            <div className="d-flex align-items-center">
                              <div
                                style={{
                                  width: "52px",
                                  height: "52px",
                                  borderRadius: "13px",
                                  boxShadow: "0px 0px 5px #00000029",
                                  border: "1px solid #E0E0E0",
                                  padding: "8px",
                                }}
                              >
                                {/* activity.un_resgister_restaurant.icon */}
                                {activity.icon ? (
                                  <Image
                                    src={activity.icon}
                                    alt="Restaurant pic"
                                    title="Restaurant Pic"
                                    fluid
                                  />
                                ) : (
                                  <Image
                                    src={require("../../../../../assets/images/OfferAndEventImages/eventnew.png")}
                                    alt="Restaurant pic"
                                    title="Restaurant Pic"
                                    fluid
                                  />
                                )}
                              </div>
                              <div className="ml-3">
                                <div className="f13-500">{activity.name}</div>
                                {/* <div className="f11-400">Location</div> */}
                              </div>
                            </div>
                          </td>
                          <td style={{ width: "20%" }}>
                            <div className="col-12 p-0 d-flex align-items-center">
                              <div className="rounded-circle enIMG33 mr-2 ">
                                {activity.user_id &&
                                activity.user_id.profile_photo &&
                                activity.user_id.profile_photo[0] ? (
                                  <Image
                                    src={
                                      activity.user_id.profile_photo &&
                                      activity.user_id.profile_photo[0]
                                    }
                                    alt="Profile pic"
                                    title="Profile Pic"
                                    fluid
                                  />
                                ) : (
                                  <Image
                                    src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                                    alt="Profile pic"
                                    title="Profile Pic"
                                    fluid
                                  />
                                )}
                              </div>
                              <div className="f12-400">
                                {activity.user_id &&
                                  activity.user_id.first_name}{" "}
                                {activity.user_id && activity.user_id.last_name}
                              </div>
                            </div>
                          </td>
                          <td style={{ width: "20%" }}>
                            <div className="f12-500 mb-1">
                              {moment(activity.createdAt).format("DD-MM-YYYY")}
                            </div>
                            <div className="f12-400">
                              {moment(activity.createdAt).format("hh:mm A")}
                            </div>
                          </td>
                          <td style={{ width: "35%" }}>
                            <div className="f12-400">{activity.place_id}</div>
                          </td>
                          {/* <td style={{ width: "15%" }}>
                            <div className="f14-500">
                              {activity.status ? <> Yes </> : <> No </>}
                            </div>
                          </td> */}
                        </tr>
                      </tbody>
                    ))
                  )}
                </Table>
              </div>
              {filterData && filterData.length !== 0 ? (
                <BasicPagination
                  totalRecords={filterData && filterData.length}
                  limit={10}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              ) : (
                <> </>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

SuperAdminNominationViewActivity.propTypes = {
  auth: PropTypes.object.isRequired,
  getNominationsActivity: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allNominationsActivity: state.commonSuperAdmin.allNominationsActivity,
});

export default connect(mapStateToProps, {
  getNominationsActivity,
})(SuperAdminNominationViewActivity);

export const Filter = (props) => {
  return (
    <React.Fragment>
      <div className="col-6">
        <div className="col-9 p-0">
          <Form.Control
            type="text"
            placeholder="Search by Restaurant Name, Google Place ID & Press Enter"
            onChange={props.onSearchChange}
            onKeyDown={props.onKeyDown}
            value={props.search}
            className="amSearch"
          />
        </div>
      </div>
      <div className="col-6">
        <div className="row justify-content-end align-items-center">
          <div className="col-5">
            <SelectFilter onDateChange={props.dateTimeChange} />
          </div>
          <div className="col-4">
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ width: "85%" }}
            >
              <SortComponent
                handleClick={props.openSortModal}
                anchorEl={props.anchorElState}
                handleClose={props.closedSortModal}
                selectClick={props.handleSelectClick}
              />
              <div
                className="f10-400"
                align="center"
                onClick={props.handleShowFilter}
              >
                <img
                  src={require("../../../../../assets/images/iconButton/filtericon.png")}
                  width="35px"
                />
                <br />
                Filter
              </div>
              <div className="f10-400" align="center">
                <img
                  src={require("../../../../../assets/images/iconButton/downloadicon.png")}
                  width="35px"
                />
                <br />
                Download
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
